import { method } from './helper/method'
import { bar } from './helper/bar'
import { terrace } from './helper/terrace'
import { scene } from './helper/scene'

/**
 * Object to control the default MontageScene
 * @param bar Controls the bars of the terraceCover
 * @param terraceCover Default values for the terraceCover when the scene loads
 * @param terrace Default values for the terrace when the scene loads
 **/

export const cover = {
  terraceCover: {
    castShadow: scene.castShadow,
    height: scene.height,
    width: scene.width,
    depth: scene.depth,
    poles: scene.poles,
    windowsTopTotal: scene.windowsTopTotal,
    windowsFrontTotal: scene.windowsFrontTotal,
    windowsSideTotal: scene.windowsSideTotal,
    model: scene.model,
    ditchForm: scene.ditchForm,
    supportForm: scene.supportForm,
    safetyGlass: scene.safetyGlass,
    safetyGlassDensity: scene.safetyGlassDensity,
    dockGlass: scene.dockGlass,
    dockTile: scene.dockTile,
    ledSpots: scene.ledSpots,
    ledSpotsSet: scene.ledSpotsSet,
    attachment: scene.attachment,
    typ: scene.typ,
    marquee: scene.marquee,
    engine: scene.engine,
    enginePosition: scene.enginePosition,
    fabricColor: scene.fabricColor,
    glassTie: scene.glassTie,
    sidewallRight: scene.sidewallRight,
    sidewallLeft: scene.sidewallLeft,
    sidewallFront: scene.sidewallFront,

    // Methods
    logBarOffset: method.logBarOffset,
    frontHeight: method.frontHeight,
    windowsTopWidth: method.windowsTopWidth,
    windowsFrontWidth: method.windowsFrontWidth,
    windowsSideWidth: method.windowsSideWidth,
    angleCompensation: method.angleCompensation,
    logsTopTotal: method.logsTopTotal,
    logsFrontTotal: method.logsFrontTotal,
    logsSideTotal: method.logsSideTotal,
  },

  // Terrace
  terrace,

  // Bar
  bar,
  ego: scene.ego,
  night: scene.night,

  environment : {
    facade: scene.facade
  }
}
